import { React, useContext, useEffect, useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { ToastContainer, toast, Slide } from "react-toastify";
import { API_URL } from "../../utilities/url";
import axios from "axios";
import AuthHeader from "../../services/auth.header";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import CryptoJS from "crypto-js";
import storage from "../../services/storage";
import { FaRegCopy, FaEye, FaEyeSlash } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid";
import { ToastrContext } from "../../provider/toastrContext";
import { Controller, useForm } from "react-hook-form";
import { base64_dec } from "../../utilities/ext-function";
import AddDeviceGroupModal from "./component/addDeviceGroupModal";
import Skeleton from "react-loading-skeleton";
import authService from "../../services/auth.service";

var $ = require("jquery");

const EditDevice = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const decryptUSR = CryptoJS.AES.decrypt(storage.get("user"), "user").toString(
    CryptoJS.enc.Utf8
  );
  const dt_user = JSON.parse(decryptUSR);
  const decryptWS = CryptoJS.AES.decrypt(storage.get("wrs"), "wrs").toString(
    CryptoJS.enc.Utf8
  );
  const workspace = JSON.parse(decryptWS);
  const { showCopy } = useContext(ToastrContext);
  const [deviceGroupList, setDeviceGroupList] = useState([]);
  const [hideSpiner, setHideSpiner] = useState(true);
  const [loading, setLoading] = useState(true);
  const [metaTab, setMetaTab] = useState("general");
  const [metaWebhookUrl, setMetaWebhookUrl] = useState("");
  const [prevMsisdn, setPrevMsisdn] = useState("");
  const [showSetupBanner, setShowSetupBanner] = useState(false);
  const [showBannerVerifyToken, setShowBannerVerifyToken] = useState(false);
  // The slug portion of the webhook URL is a bearer secret. Mask by default in
  // the persistent form field; reveal by default in the post-creation banner
  // since the user needs to copy it once into Meta App Dashboard.
  const [showWebhookSlug, setShowWebhookSlug] = useState(false);
  const [showBannerWebhookSlug, setShowBannerWebhookSlug] = useState(true);
  const [rotatingSlug, setRotatingSlug] = useState(false);

  // maskWebhookSlug replaces the path segment after the last '/' with bullets,
  // so the URL shape (https://.../wh/<tenant>/...) is still recognizable.
  const maskWebhookSlug = (url) => {
    if (!url) return "";
    const idx = url.lastIndexOf("/");
    if (idx < 0) return "•".repeat(8);
    return url.slice(0, idx + 1) + "•".repeat(8);
  };
  const [showSecrets, setShowSecrets] = useState({
    app_secret: false,
    instagram_app_secret: false,
    system_user_token: false,
    webhook_verify_token: false,
    wa_access_token: false,
    msgr_page_token: false,
    ig_access_token: false,
  });
  const toggleSecret = (key) =>
    setShowSecrets((prev) => ({ ...prev, [key]: !prev[key] }));

  useEffect(() => {
    getDeviceGroupList();
  }, []);

  useEffect(() => {
    if (deviceGroupList.length > 0) {
      getData();
    }
  }, [deviceGroupList]);

  function getData() {
    axios
      .post(
        API_URL + "device",
        {
          idt_device: base64_dec(location.pathname.split("/")[3]),
        },
        {
          headers: AuthHeader(),
        }
      )
      .then((res) => {
        if (res.data.success === true) {
          var resp = res.data.data;
          let data1 = null;
          let data2 = null;
          let metaCfg = null;
          if (resp.verification_code) {
            if (resp.type_device === "META") {
              try {
                metaCfg = JSON.parse(resp.verification_code);
              } catch (e) {
                metaCfg = null;
              }
            } else {
              [data1, data2] = resp.verification_code.split(" ");
            }
          }
          setValue("device_name", resp.name);
          setValue("quota", resp.quota);
          setValue("service_type", resp.type_service);
          setValue("device_type", resp.type_device);
          setValue("msisdn", "+" + resp.msisdn);
          setValue("min_sending_period", resp.min_sending_period);
          setValue("max_sending_period", resp.max_sending_period);
          setValue("channel_secret", data1 || "");
          setValue("channel_at", data2 || "");
          setValue(
            "webhook_url",
            "https://api.otokata.id:5001/callback?s=" + resp.msisdn
          );
          if (resp && resp.idt_device_group) {
            const selectedOption = deviceGroupList.find(
              (option) => option.value === resp.idt_device_group
            );
            setValue("device_group", selectedOption);
          }
          // Meta App defaults + populate from existing config
          setValue("meta_graph_api_version", metaCfg?.graph_api_version || "v25.0");
          setValue("meta_app_id", metaCfg?.app_id || "");
          setValue("meta_app_secret", metaCfg?.app_secret || "");
          setValue("meta_instagram_app_secret", metaCfg?.instagram_app_secret || "");
          setValue("meta_system_user_token", metaCfg?.system_user_token || "");
          setValue("meta_webhook_verify_token", metaCfg?.webhook_verify_token || "");
          setValue("meta_auto_reply_text", metaCfg?.auto_reply_text || "");
          const wa = metaCfg?.whatsapp || {};
          const msgr = metaCfg?.messenger || {};
          const ig = metaCfg?.instagram || {};
          const hasAny = (o) => Object.values(o || {}).some((v) => v && String(v).length > 0);
          setValue("enable_whatsapp", hasAny(wa));
          setValue("meta_wa_phone_number_id", wa.phone_number_id || "");
          setValue("meta_wa_business_account_id", wa.business_account_id || "");
          setValue("meta_wa_access_token", wa.access_token || "");
          setValue("enable_messenger", hasAny(msgr));
          setValue("meta_msgr_page_id", msgr.page_id || "");
          setValue("meta_msgr_page_token", msgr.page_token || "");
          setValue("enable_instagram", hasAny({ page_id: ig.page_id, user_id: ig.user_id, access_token: ig.access_token }));
          setValue("meta_ig_auth", ig.auth || "ig_login");
          setValue("meta_ig_page_id", ig.page_id || "");
          setValue("meta_ig_user_id", ig.user_id || "");
          setValue("meta_ig_access_token", ig.access_token || "");
          setMetaWebhookUrl(resp.meta_webhook_url || "");
          setPrevMsisdn(resp.msisdn || "");
          if (resp.type_device === "META" && location.search.includes("just_created=1")) {
            setShowSetupBanner(true);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  }

  async function getDeviceGroupList() {
    axios
      .post(
        API_URL + "device-group-list",
        {
          idt_user: dt_user.idt_user,
          idt_user_workspace: workspace.idt_user_workspace,
        },
        {
          headers: AuthHeader(),
        }
      )
      .then((res) => {
        if (res.data.success === true) {
          if (res.data.success === true) {
            const maps = res.data.data.map(function (d) {
              const map = {
                value: d.idt_device_group,
                label: d.name,
              };
              return map;
            });
            setDeviceGroupList(maps);
          }
        }
      })
      .catch((error) => {});
  }

  function handleRotateWebhookSlug() {
    if (rotatingSlug) return;
    const ok = window.confirm(
      "Rotate webhook slug?\n\nThis invalidates the current webhook URL immediately. " +
        "You will need to repaste the new URL into your Meta App Dashboard before Meta " +
        "can deliver events again."
    );
    if (!ok) return;
    setRotatingSlug(true);
    axios
      .post(
        API_URL + "rotate-meta-slug",
        {
          idt_device: base64_dec(location.pathname.split("/")[3]),
        },
        {
          headers: AuthHeader(),
        }
      )
      .then((res) => {
        if (res.data.success === true) {
          const newUrl = res.data.data?.meta_webhook_url || "";
          const newMsisdn = res.data.data?.msisdn || "";
          setMetaWebhookUrl(newUrl);
          setPrevMsisdn(newMsisdn);
          setShowWebhookSlug(true);
          setShowSetupBanner(true);
          setShowBannerWebhookSlug(true);
          toast.success(
            "Webhook URL rotated — repaste it into Meta App Dashboard.",
            { position: "top-right", theme: "colored", transition: Slide }
          );
        } else {
          toast.error(res.data.message || "Failed to rotate webhook slug", {
            position: "top-right",
            theme: "colored",
            transition: Slide,
          });
        }
      })
      .catch(() => {
        toast.error("Failed to rotate webhook slug", {
          position: "top-right",
          theme: "colored",
          transition: Slide,
        });
      })
      .finally(() => setRotatingSlug(false));
  }

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: 4,
      minHeight: 32,
      borderColor: state.isFocused ? "#7f7f7f" : base.borderColor, // Ubah warna border saat fokus
      boxShadow: state.isFocused ? "0 0 0 0.1px #7f7f7f" : base.boxShadow, // Hilangkan shadow bawaan
      "&:hover": {
        borderColor: state.isFocused ? "#7f7f7f" : base.borderColor, // Warna hover
      },
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      padding: 0,
      margin: -2,
    }),
  };

  const {
    handleSubmit,
    register,
    control,
    watch,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();

  const selectedDeviceType = watch("device_type");
  const isMetaApp = selectedDeviceType === "META";
  const enableWhatsapp = watch("enable_whatsapp");
  const enableMessenger = watch("enable_messenger");
  const enableInstagram = watch("enable_instagram");

  const onSubmit = (data) => {
    const isMeta = data.device_type === "META";
    let metaConfigStr = null;
    if (isMeta) {
      const metaConfig = {
        graph_api_version: data.meta_graph_api_version || "",
        app_id: data.meta_app_id || "",
        app_secret: data.meta_app_secret || "",
        instagram_app_secret: data.meta_instagram_app_secret || "",
        system_user_token: data.meta_system_user_token || "",
        webhook_verify_token: data.meta_webhook_verify_token || "",
        auto_reply_text: data.meta_auto_reply_text || "",
        whatsapp: data.enable_whatsapp
          ? {
              phone_number_id: data.meta_wa_phone_number_id || "",
              business_account_id: data.meta_wa_business_account_id || "",
              access_token: data.meta_wa_access_token || "",
            }
          : { phone_number_id: "", business_account_id: "", access_token: "" },
        messenger: data.enable_messenger
          ? {
              page_id: data.meta_msgr_page_id || "",
              page_token: data.meta_msgr_page_token || "",
            }
          : { page_id: "", page_token: "" },
        instagram: data.enable_instagram
          ? {
              auth: data.meta_ig_auth || "ig_login",
              page_id: data.meta_ig_page_id || "",
              user_id: data.meta_ig_user_id || "",
              access_token: data.meta_ig_access_token || "",
            }
          : { auth: "ig_login", page_id: "", user_id: "", access_token: "" },
      };
      metaConfigStr = JSON.stringify(metaConfig);
    }

    axios
      .post(
        API_URL + "update-device",
        {
          idt_device: base64_dec(location.pathname.split("/")[3]),
          idt_user_workspace: workspace.idt_user_workspace,
          name: data.device_name,
          type_device: data.device_type,
          msisdn: isMeta ? "" : data.msisdn.replace("+", ""),
          type_service: data.service_type,
          channel_secret: data.channel_secret,
          channel_at: data.channel_at,
          webhook_url: data.webhook_url,
          idt_device_group: data.device_group.value,
          quota: data.quota,
          min_sending_period: data.min_sending_period,
          max_sending_period: data.max_sending_period,
          meta_config: metaConfigStr,
        },
        {
          headers: AuthHeader(),
        }
      )
      .then((res) => {
        if (res.data.success === true) {
          setHideSpiner(true);
          localStorage.setItem("alertu", true);
          if (isMeta) {
            const newMsisdn = res.data.data?.msisdn || "";
            const newUrl = res.data.data?.meta_webhook_url || "";
            if (newMsisdn && newMsisdn !== prevMsisdn) {
              setMetaWebhookUrl(newUrl);
              setPrevMsisdn(newMsisdn);
              setShowSetupBanner(true);
              toast.info("Webhook URL changed — repaste into Meta App Dashboard.", {
                position: "top-right",
                theme: "colored",
                transition: Slide,
                autoClose: 4000,
              });
              window.scrollTo({ top: 0, behavior: "smooth" });
              return;
            }
          }
          navigate("/device");
        } else {
          toast.error(res.data.message, {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          });
          setHideSpiner(true);
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  const handleGenerateWCL = () => {
    const newUUID = uuidv4();
    setValue(
      "webhook_url",
      "https://api.otokata.id:5001/callback?s=" + newUUID
    );
    clearErrors("webhook_url");
  };

  /* Copy */
  const handleCopyClick = () => {
    const webhookUrl = watch("webhook_url");
    if (webhookUrl) {
      navigator.clipboard.writeText(webhookUrl);
      showCopy("Webhook URL copied to clipboard");
    }
  };

  // Modal
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="container-fluid p-0">
      <div className="row mb-2 mb-xl-3">
        <div className="col-auto">
          <h5>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/device">Device</Link>
                </li>
                <li className="breadcrumb-item active">Edit Device</li>
              </ol>
            </nav>
          </h5>
        </div>
        <ToastContainer />
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="card rounded-4 shadow-lg">
            <div className="col-md-11 col-sm-12 mx-auto">
              <div className="card-header rounded-4">
                <h5 className="card-title text-center">Edit Device</h5>
              </div>
              <div className="card-body">
                <div className="card-body h-100">
                  {isMetaApp && showSetupBanner && !loading && (
                    <div className="alert alert-info alert-dismissible mb-4" role="alert">
                      <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => setShowSetupBanner(false)}
                      ></button>
                      <h6 className="alert-heading mb-2">
                        Connect this device to Meta App Dashboard
                      </h6>
                      <p className="mb-3 small">
                        Finish wiring up the webhook by pasting the two values below into your Meta App.
                        Meta will send a verification request to our gateway and confirm the subscription.
                      </p>
                      <ol className="mb-0 small ps-3">
                        <li className="mb-2">
                          Open Meta App Dashboard &rarr; Webhooks &rarr; Edit subscription for the product you want
                          (WhatsApp Business / Messenger / Instagram).
                        </li>
                        <li className="mb-2">
                          Paste this <strong>Callback URL</strong>:
                          <div className="input-group input-group-sm mt-1">
                            <input
                              type="text"
                              className="form-control"
                              value={
                                showBannerWebhookSlug
                                  ? metaWebhookUrl
                                  : maskWebhookSlug(metaWebhookUrl)
                              }
                              readOnly
                            />
                            <span
                              className="input-group-text c-pointer"
                              onClick={() => setShowBannerWebhookSlug((v) => !v)}
                            >
                              {showBannerWebhookSlug ? <FaEyeSlash /> : <FaEye />}
                            </span>
                            <div
                              className="input-group-text c-pointer"
                              onClick={() => {
                                if (metaWebhookUrl) {
                                  navigator.clipboard.writeText(metaWebhookUrl);
                                  showCopy("Webhook URL copied to clipboard");
                                }
                              }}
                            >
                              <FaRegCopy />
                            </div>
                          </div>
                        </li>
                        <li className="mb-2">
                          Paste this <strong>Verify Token</strong> (the same value you entered in the form below):
                          <div className="input-group input-group-sm mt-1">
                            <input
                              type={showBannerVerifyToken ? "text" : "password"}
                              className="form-control"
                              value={watch("meta_webhook_verify_token") || ""}
                              readOnly
                            />
                            <span
                              className="input-group-text c-pointer"
                              onClick={() => setShowBannerVerifyToken((v) => !v)}
                            >
                              {showBannerVerifyToken ? <FaEyeSlash /> : <FaEye />}
                            </span>
                            <div
                              className="input-group-text c-pointer"
                              onClick={() => {
                                const vt = watch("meta_webhook_verify_token");
                                if (vt) {
                                  navigator.clipboard.writeText(vt);
                                  showCopy("Verify Token copied to clipboard");
                                }
                              }}
                            >
                              <FaRegCopy />
                            </div>
                          </div>
                        </li>
                        <li>
                          Click <strong>"Verify and Save"</strong> in Meta. Once Meta confirms the subscription,
                          you can dismiss this banner.
                        </li>
                      </ol>
                    </div>
                  )}
                  <form id="form-validation" onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      <div className="col-md-6">
                        {/* Device Name */}
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Device Name<span className="required">*</span>
                          </label>
                          <div className="col-sm-8">
                            {!loading ? (
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Device Name"
                                {...register("device_name", {
                                  required: "Device Name is required",
                                })}
                              />
                            ) : (
                              <Skeleton height={32} className="form-control" />
                            )}
                            {errors.device_name && (
                              <span className="text-danger">
                                {errors.device_name.message}
                              </span>
                            )}
                          </div>
                        </div>

                        {/* Device Type */}
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Device Type<span className="required">*</span>
                          </label>
                          <div className="col-sm-8">
                            {!loading ? (
                              <>
                                <div className="form-check form-check-inline">
                                  <input
                                    type="radio"
                                    id="device_type_1"
                                    className="form-check-input"
                                    value="WHATSAPP"
                                    {...register("device_type", {
                                      required: "Device Type is required",
                                    })}
                                  />
                                  <label
                                    htmlFor="device_type_1"
                                    className="form-check-label"
                                  >
                                    WhatsApp
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    type="radio"
                                    id="device_type_2"
                                    className="form-check-input"
                                    value="TELEGRAM"
                                    {...register("device_type", {
                                      required: "Device Type is required",
                                    })}
                                  />
                                  <label
                                    htmlFor="device_type_2"
                                    className="form-check-label"
                                  >
                                    Telegram
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    type="radio"
                                    id="device_type_3"
                                    className="form-check-input"
                                    value="LINE"
                                    {...register("device_type", {
                                      required: "Device Type is required",
                                    })}
                                  />
                                  <label
                                    htmlFor="device_type_3"
                                    className="form-check-label"
                                  >
                                    Line
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    type="radio"
                                    id="device_type_4"
                                    className="form-check-input"
                                    value="META"
                                    {...register("device_type", {
                                      required: "Device Type is required",
                                    })}
                                  />
                                  <label
                                    htmlFor="device_type_4"
                                    className="form-check-label"
                                  >
                                    Meta App
                                  </label>
                                </div>
                              </>
                            ) : (
                              <Skeleton height={32} className="form-control" />
                            )}
                            {/* Error message */}
                            {errors.device_type && (
                              <div className="mt-2">
                                <span className="text-danger">
                                  {errors.device_type.message}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Conditional Inputs */}
                        {selectedDeviceType !== "LINE" && !isMetaApp && (
                          <div className="mb-3 row">
                            <label className="col-form-label col-sm-4 text-sm-right">
                              Nomor MSISDN<span className="required">*</span>
                            </label>
                            <div className="col-sm-8">
                              {!loading ? (
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Nomor MSISDN"
                                  {...register("msisdn", {
                                    required: "Nomor MSISDN is required",
                                  })}
                                />
                              ) : (
                                <Skeleton
                                  height={32}
                                  className="form-control"
                                />
                              )}
                              {errors.msisdn && (
                                <span className="text-danger">
                                  {errors.msisdn.message}
                                </span>
                              )}
                            </div>
                          </div>
                        )}

                        {selectedDeviceType === "LINE" && (
                          <>
                            <div className="mb-3 row">
                              <label className="col-form-label col-sm-4 text-sm-right">
                                Channel Secret
                                <span className="required">*</span>
                              </label>
                              <div className="col-sm-8">
                                {!loading ? (
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Channel Secret"
                                    {...register("channel_secret", {
                                      required: "Channel Secret is required",
                                    })}
                                  />
                                ) : (
                                  <Skeleton
                                    height={32}
                                    className="form-control"
                                  />
                                )}
                                {errors.channel_secret && (
                                  <span className="text-danger">
                                    {errors.channel_secret.message}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="col-form-label col-sm-4 text-sm-right">
                                Channel Access Token
                                <span className="required">*</span>
                              </label>
                              <div className="col-sm-8">
                                {!loading ? (
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Channel Access Token"
                                    {...register("channel_at", {
                                      required:
                                        "Channel Access Token is required",
                                    })}
                                  />
                                ) : (
                                  <Skeleton
                                    height={32}
                                    className="form-control"
                                  />
                                )}
                                {errors.channel_at && (
                                  <span className="text-danger">
                                    {errors.channel_at.message}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="col-form-label col-sm-4 text-sm-right">
                                Webhook URL<span className="required">*</span>
                              </label>
                              <div className="col-sm-8">
                                {!loading ? (
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Webhook URL"
                                      readOnly
                                      {...register("webhook_url", {
                                        required: "Webhook URL is required",
                                      })}
                                    />

                                    <div
                                      className="input-group-text c-pointer"
                                      onClick={handleCopyClick}
                                    >
                                      <FaRegCopy />
                                    </div>
                                    <button
                                      className="btn btn-primary ms-2"
                                      type="button"
                                      onClick={handleGenerateWCL}
                                    >
                                      Generate
                                    </button>
                                    {errors.webhook_url && (
                                      <span className="text-danger">
                                        {errors.webhook_url.message}
                                      </span>
                                    )}
                                  </div>
                                ) : (
                                  <div className="d-block">
                                    <Skeleton
                                      height={32}
                                      className="form-control"
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          </>
                        )}

                        {/* Device Group */}
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Device Group<span className="required">*</span>
                          </label>
                          <div className="col-sm-8">
                            {!loading ? (
                              <>
                                <Controller
                                  name="device_group"
                                  control={control}
                                  rules={{
                                    required: "Device Group is required",
                                  }}
                                  render={({ field }) => (
                                    <Select
                                      {...field}
                                      options={deviceGroupList}
                                      styles={customStyles}
                                      placeholder="Select Device Group"
                                    />
                                  )}
                                />
                                <div className="mt-2">
                                  <Button
                                    variant="primary"
                                    onClick={() => setShowModal(true)}
                                  >
                                    Add Device Group
                                  </Button>
                                </div>
                              </>
                            ) : (
                              <Skeleton height={32} className="form-control" />
                            )}
                            {errors.device_group && (
                              <span className="text-danger">
                                {errors.device_group.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        {/* Service Type */}
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Service Type
                            <span className="required">*</span>
                          </label>
                          <div className="col-sm-8">
                            {!loading ? (
                              <div className="form-group mt-1">
                                <div className="form-check form-check-inline">
                                  <input
                                    type="radio"
                                    id="service_type_1"
                                    className="form-check-input"
                                    value="BROADCAST"
                                    {...register("service_type", {
                                      required: "Type Service is required",
                                    })}
                                  />
                                  <label
                                    htmlFor="service_type_1"
                                    className="form-check-label"
                                  >
                                    Broadcast
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    type="radio"
                                    id="service_type_2"
                                    className="form-check-input"
                                    value="RECEIVER"
                                    {...register("service_type", {
                                      required: "Type Service is required",
                                    })}
                                  />
                                  <label
                                    htmlFor="service_type_2"
                                    className="form-check-label"
                                  >
                                    Receiver
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    type="radio"
                                    id="service_type_3"
                                    className="form-check-input"
                                    value="HYBRID"
                                    {...register("service_type", {
                                      required: "Type Service is required",
                                    })}
                                  />
                                  <label
                                    htmlFor="service_type_3"
                                    className="form-check-label"
                                  >
                                    Hybrid/Bot
                                  </label>
                                </div>
                              </div>
                            ) : (
                              <Skeleton height={32} className="form-control" />
                            )}
                            {/* Error message */}
                            {errors.service_type && (
                              <div className="mt-2">
                                <span className="text-danger">
                                  {errors.service_type.message}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Quota Per Day */}
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Quota Per Day
                            <span className="required">*</span>
                          </label>
                          <div className="col-sm-8">
                            {!loading ? (
                              <input
                                type="number"
                                className="form-control"
                                {...register("quota", {
                                  required: "Quota is required",
                                  valueAsNumber: true,
                                })}
                                placeholder="Quota"
                              />
                            ) : (
                              <Skeleton height={32} className="form-control" />
                            )}
                            {errors.quota && (
                              <span className="text-danger">
                                {errors.quota.message}
                              </span>
                            )}
                          </div>
                        </div>

                        {/* Min. Sending Period */}
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Min. Sending Period
                            <span className="required">*</span>
                          </label>
                          <div className="col-sm-8">
                            {!loading ? (
                              <input
                                type="number"
                                className="form-control"
                                {...register("min_sending_period", {
                                  required:
                                    "Minimum sending period is required",
                                  valueAsNumber: true,
                                })}
                                placeholder="Min. Sending Period"
                              />
                            ) : (
                              <Skeleton height={32} className="form-control" />
                            )}
                            {errors.min_sending_period && (
                              <span className="text-danger">
                                {errors.min_sending_period.message}
                              </span>
                            )}
                          </div>
                        </div>

                        {/* Max. Sending Period */}
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Max. Sending Period
                            <span className="required">*</span>
                          </label>
                          <div className="col-sm-8">
                            {!loading ? (
                              <input
                                type="number"
                                className="form-control"
                                {...register("max_sending_period", {
                                  required:
                                    "Maximum sending period is required",
                                  valueAsNumber: true,
                                })}
                                placeholder="Max. Sending Period"
                              />
                            ) : (
                              <Skeleton height={32} className="form-control" />
                            )}
                            {errors.max_sending_period && (
                              <span className="text-danger">
                                {errors.max_sending_period.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {isMetaApp && !loading && (
                      <div className="row">
                        <div className="col-12">
                          <hr />
                          <h6 className="mb-3">Meta App Configuration</h6>
                          <Tab.Container
                            activeKey={metaTab}
                            onSelect={(k) => setMetaTab(k || "general")}
                          >
                            <Nav variant="tabs" className="mb-3">
                              <Nav.Item>
                                <Nav.Link eventKey="general">
                                  General<span className="required">*</span>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link eventKey="whatsapp">
                                  WhatsApp Business API
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link eventKey="messenger">
                                  Messenger
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link eventKey="instagram">
                                  Instagram
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>
                            <Tab.Content>
                              {/* General */}
                              <Tab.Pane eventKey="general">
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Graph API Version
                                        <span className="required">*</span>
                                      </label>
                                      <div className="col-sm-8">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="v25.0"
                                          {...register("meta_graph_api_version", {
                                            required: isMetaApp
                                              ? "Graph API Version is required"
                                              : false,
                                          })}
                                        />
                                        {errors.meta_graph_api_version && (
                                          <span className="text-danger">
                                            {errors.meta_graph_api_version.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        App ID
                                        <span className="required">*</span>
                                      </label>
                                      <div className="col-sm-8">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="App ID"
                                          {...register("meta_app_id", {
                                            required: isMetaApp
                                              ? "App ID is required"
                                              : false,
                                          })}
                                        />
                                        {errors.meta_app_id && (
                                          <span className="text-danger">
                                            {errors.meta_app_id.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        App Secret
                                        <span className="required">*</span>
                                      </label>
                                      <div className="col-sm-8">
                                        <div className="input-group">
                                          <input
                                            type={
                                              showSecrets.app_secret
                                                ? "text"
                                                : "password"
                                            }
                                            className="form-control"
                                            placeholder="App Secret"
                                            {...register("meta_app_secret", {
                                              required: isMetaApp
                                                ? "App Secret is required"
                                                : false,
                                            })}
                                          />
                                          <span
                                            className="input-group-text c-pointer"
                                            onClick={() =>
                                              toggleSecret("app_secret")
                                            }
                                          >
                                            {showSecrets.app_secret ? (
                                              <FaEyeSlash />
                                            ) : (
                                              <FaEye />
                                            )}
                                          </span>
                                        </div>
                                        {errors.meta_app_secret && (
                                          <span className="text-danger">
                                            {errors.meta_app_secret.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Instagram App Secret
                                        <span className="required">*</span>
                                      </label>
                                      <div className="col-sm-8">
                                        <div className="input-group">
                                          <input
                                            type={
                                              showSecrets.instagram_app_secret
                                                ? "text"
                                                : "password"
                                            }
                                            className="form-control"
                                            placeholder="Instagram App Secret"
                                            {...register(
                                              "meta_instagram_app_secret",
                                              {
                                                required: isMetaApp
                                                  ? "Instagram App Secret is required"
                                                  : false,
                                              }
                                            )}
                                          />
                                          <span
                                            className="input-group-text c-pointer"
                                            onClick={() =>
                                              toggleSecret("instagram_app_secret")
                                            }
                                          >
                                            {showSecrets.instagram_app_secret ? (
                                              <FaEyeSlash />
                                            ) : (
                                              <FaEye />
                                            )}
                                          </span>
                                        </div>
                                        {errors.meta_instagram_app_secret && (
                                          <span className="text-danger">
                                            {
                                              errors.meta_instagram_app_secret
                                                .message
                                            }
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        System User Token
                                        <span className="required">*</span>
                                      </label>
                                      <div className="col-sm-8">
                                        <div className="input-group">
                                          <textarea
                                            rows={2}
                                            className="form-control font-monospace"
                                            placeholder="System User Token"
                                            style={{
                                              WebkitTextSecurity: showSecrets.system_user_token
                                                ? "none"
                                                : "disc",
                                            }}
                                            {...register(
                                              "meta_system_user_token",
                                              {
                                                required: isMetaApp
                                                  ? "System User Token is required"
                                                  : false,
                                              }
                                            )}
                                          />
                                          <span
                                            className="input-group-text c-pointer"
                                            onClick={() =>
                                              toggleSecret("system_user_token")
                                            }
                                          >
                                            {showSecrets.system_user_token ? (
                                              <FaEyeSlash />
                                            ) : (
                                              <FaEye />
                                            )}
                                          </span>
                                        </div>
                                        {errors.meta_system_user_token && (
                                          <span className="text-danger">
                                            {errors.meta_system_user_token.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Webhook Verify Token
                                        <span className="required">*</span>
                                      </label>
                                      <div className="col-sm-8">
                                        <div className="input-group">
                                          <input
                                            type={
                                              showSecrets.webhook_verify_token
                                                ? "text"
                                                : "password"
                                            }
                                            className="form-control"
                                            placeholder="Webhook Verify Token"
                                            {...register(
                                              "meta_webhook_verify_token",
                                              {
                                                required: isMetaApp
                                                  ? "Webhook Verify Token is required"
                                                  : false,
                                              }
                                            )}
                                          />
                                          <span
                                            className="input-group-text c-pointer"
                                            onClick={() =>
                                              toggleSecret("webhook_verify_token")
                                            }
                                          >
                                            {showSecrets.webhook_verify_token ? (
                                              <FaEyeSlash />
                                            ) : (
                                              <FaEye />
                                            )}
                                          </span>
                                        </div>
                                        {errors.meta_webhook_verify_token && (
                                          <span className="text-danger">
                                            {
                                              errors.meta_webhook_verify_token
                                                .message
                                            }
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Webhook URL
                                      </label>
                                      <div className="col-sm-8">
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Save device to generate webhook URL"
                                            value={
                                              showWebhookSlug
                                                ? metaWebhookUrl
                                                : maskWebhookSlug(metaWebhookUrl)
                                            }
                                            readOnly
                                          />
                                          <span
                                            className="input-group-text c-pointer"
                                            onClick={() => setShowWebhookSlug((v) => !v)}
                                          >
                                            {showWebhookSlug ? <FaEyeSlash /> : <FaEye />}
                                          </span>
                                          <div
                                            className="input-group-text c-pointer"
                                            onClick={() => {
                                              if (metaWebhookUrl) {
                                                navigator.clipboard.writeText(metaWebhookUrl);
                                                showCopy("Webhook URL copied to clipboard");
                                              }
                                            }}
                                          >
                                            <FaRegCopy />
                                          </div>
                                          <button
                                            type="button"
                                            className="btn btn-outline-secondary btn-sm"
                                            onClick={handleRotateWebhookSlug}
                                            disabled={rotatingSlug || !metaWebhookUrl}
                                            title="Rotate webhook slug (invalidates the current URL)"
                                          >
                                            {rotatingSlug ? "Rotating..." : "Rotate"}
                                          </button>
                                        </div>
                                        <small className="text-muted">
                                          Treat this URL as a secret — it is the only credential the gateway accepts.
                                          Paste it into Meta App Dashboard &rarr; Webhooks &rarr; Callback URL,
                                          and use the Webhook Verify Token above as the Verify Token. Renaming this
                                          device no longer rotates the URL; use the Rotate button if the URL leaks.
                                        </small>
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Auto Reply Text
                                      </label>
                                      <div className="col-sm-8">
                                        <textarea
                                          rows={2}
                                          className="form-control"
                                          placeholder="Optional auto-reply"
                                          {...register("meta_auto_reply_text")}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Tab.Pane>

                              {/* WhatsApp Business API */}
                              <Tab.Pane eventKey="whatsapp">
                                <div className="form-check mb-3">
                                  <input
                                    type="checkbox"
                                    id="enable_whatsapp"
                                    className="form-check-input"
                                    {...register("enable_whatsapp")}
                                  />
                                  <label
                                    htmlFor="enable_whatsapp"
                                    className="form-check-label"
                                  >
                                    Enable WhatsApp Business API
                                  </label>
                                </div>
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Phone Number ID
                                        {enableWhatsapp && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Phone Number ID"
                                          disabled={!enableWhatsapp}
                                          {...register(
                                            "meta_wa_phone_number_id",
                                            {
                                              required:
                                                isMetaApp && enableWhatsapp
                                                  ? "Phone Number ID is required"
                                                  : false,
                                            }
                                          )}
                                        />
                                        {errors.meta_wa_phone_number_id && (
                                          <span className="text-danger">
                                            {
                                              errors.meta_wa_phone_number_id
                                                .message
                                            }
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Business Account ID
                                        {enableWhatsapp && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Business Account ID"
                                          disabled={!enableWhatsapp}
                                          {...register(
                                            "meta_wa_business_account_id",
                                            {
                                              required:
                                                isMetaApp && enableWhatsapp
                                                  ? "Business Account ID is required"
                                                  : false,
                                            }
                                          )}
                                        />
                                        {errors.meta_wa_business_account_id && (
                                          <span className="text-danger">
                                            {
                                              errors.meta_wa_business_account_id
                                                .message
                                            }
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Access Token
                                        {enableWhatsapp && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <div className="input-group">
                                          <textarea
                                            rows={2}
                                            className="form-control font-monospace"
                                            placeholder="Access Token"
                                            disabled={!enableWhatsapp}
                                            style={{
                                              WebkitTextSecurity: showSecrets.wa_access_token
                                                ? "none"
                                                : "disc",
                                            }}
                                            {...register(
                                              "meta_wa_access_token",
                                              {
                                                required:
                                                  isMetaApp && enableWhatsapp
                                                    ? "Access Token is required"
                                                    : false,
                                              }
                                            )}
                                          />
                                          <span
                                            className="input-group-text c-pointer"
                                            onClick={() =>
                                              toggleSecret("wa_access_token")
                                            }
                                          >
                                            {showSecrets.wa_access_token ? (
                                              <FaEyeSlash />
                                            ) : (
                                              <FaEye />
                                            )}
                                          </span>
                                        </div>
                                        {errors.meta_wa_access_token && (
                                          <span className="text-danger">
                                            {errors.meta_wa_access_token.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Tab.Pane>

                              {/* Messenger */}
                              <Tab.Pane eventKey="messenger">
                                <div className="form-check mb-3">
                                  <input
                                    type="checkbox"
                                    id="enable_messenger"
                                    className="form-check-input"
                                    {...register("enable_messenger")}
                                  />
                                  <label
                                    htmlFor="enable_messenger"
                                    className="form-check-label"
                                  >
                                    Enable Messenger
                                  </label>
                                </div>
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Page ID
                                        {enableMessenger && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Page ID"
                                          disabled={!enableMessenger}
                                          {...register("meta_msgr_page_id", {
                                            required:
                                              isMetaApp && enableMessenger
                                                ? "Page ID is required"
                                                : false,
                                          })}
                                        />
                                        {errors.meta_msgr_page_id && (
                                          <span className="text-danger">
                                            {errors.meta_msgr_page_id.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Page Token
                                        {enableMessenger && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <div className="input-group">
                                          <textarea
                                            rows={2}
                                            className="form-control font-monospace"
                                            placeholder="Page Token"
                                            disabled={!enableMessenger}
                                            style={{
                                              WebkitTextSecurity: showSecrets.msgr_page_token
                                                ? "none"
                                                : "disc",
                                            }}
                                            {...register("meta_msgr_page_token", {
                                              required:
                                                isMetaApp && enableMessenger
                                                  ? "Page Token is required"
                                                  : false,
                                            })}
                                          />
                                          <span
                                            className="input-group-text c-pointer"
                                            onClick={() =>
                                              toggleSecret("msgr_page_token")
                                            }
                                          >
                                            {showSecrets.msgr_page_token ? (
                                              <FaEyeSlash />
                                            ) : (
                                              <FaEye />
                                            )}
                                          </span>
                                        </div>
                                        {errors.meta_msgr_page_token && (
                                          <span className="text-danger">
                                            {errors.meta_msgr_page_token.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Tab.Pane>

                              {/* Instagram */}
                              <Tab.Pane eventKey="instagram">
                                <div className="form-check mb-3">
                                  <input
                                    type="checkbox"
                                    id="enable_instagram"
                                    className="form-check-input"
                                    {...register("enable_instagram")}
                                  />
                                  <label
                                    htmlFor="enable_instagram"
                                    className="form-check-label"
                                  >
                                    Enable Instagram
                                  </label>
                                </div>
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Auth Method
                                        {enableInstagram && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <select
                                          className="form-select"
                                          disabled={!enableInstagram}
                                          {...register("meta_ig_auth", {
                                            required:
                                              isMetaApp && enableInstagram
                                                ? "Auth Method is required"
                                                : false,
                                          })}
                                        >
                                          <option value="ig_login">
                                            ig_login
                                          </option>
                                          <option value="fb_login">
                                            fb_login
                                          </option>
                                        </select>
                                        {errors.meta_ig_auth && (
                                          <span className="text-danger">
                                            {errors.meta_ig_auth.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Page ID
                                        {enableInstagram && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Page ID"
                                          disabled={!enableInstagram}
                                          {...register("meta_ig_page_id", {
                                            required:
                                              isMetaApp && enableInstagram
                                                ? "Page ID is required"
                                                : false,
                                          })}
                                        />
                                        {errors.meta_ig_page_id && (
                                          <span className="text-danger">
                                            {errors.meta_ig_page_id.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        User ID
                                        {enableInstagram && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="User ID"
                                          disabled={!enableInstagram}
                                          {...register("meta_ig_user_id", {
                                            required:
                                              isMetaApp && enableInstagram
                                                ? "User ID is required"
                                                : false,
                                          })}
                                        />
                                        {errors.meta_ig_user_id && (
                                          <span className="text-danger">
                                            {errors.meta_ig_user_id.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Access Token
                                        {enableInstagram && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <div className="input-group">
                                          <textarea
                                            rows={2}
                                            className="form-control font-monospace"
                                            placeholder="Access Token"
                                            disabled={!enableInstagram}
                                            style={{
                                              WebkitTextSecurity: showSecrets.ig_access_token
                                                ? "none"
                                                : "disc",
                                            }}
                                            {...register(
                                              "meta_ig_access_token",
                                              {
                                                required:
                                                  isMetaApp && enableInstagram
                                                    ? "Access Token is required"
                                                    : false,
                                              }
                                            )}
                                          />
                                          <span
                                            className="input-group-text c-pointer"
                                            onClick={() =>
                                              toggleSecret("ig_access_token")
                                            }
                                          >
                                            {showSecrets.ig_access_token ? (
                                              <FaEyeSlash />
                                            ) : (
                                              <FaEye />
                                            )}
                                          </span>
                                        </div>
                                        {errors.meta_ig_access_token && (
                                          <span className="text-danger">
                                            {errors.meta_ig_access_token.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Tab.Pane>
                            </Tab.Content>
                          </Tab.Container>
                        </div>
                      </div>
                    )}

                    <div className="mt-4">
                      <Link to="/device" className="btn btn-danger btn-md">
                        Cancel
                      </Link>
                      <button
                        type="submit"
                        className="btn btn-success btn-md float-end"
                        disabled={loading}
                      >
                        Update
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal */}
      <AddDeviceGroupModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        onChangeData={() => getDeviceGroupList()}
      />
    </div>
  );
};

export default EditDevice;
